import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { CreateTaskGroupCommand, TaskGroupType, UpdateTaskGroupCommand } from '../state/types';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class TaskGroupService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'taskgroup';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  getTaskGroups(): Observable<TaskGroupType[]> {
    return this.http
      .get<TaskGroupType[]>(this.url, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  createTaskGroup(createTaskGroup: CreateTaskGroupCommand): Observable<TaskGroupType> {
    return this.http
      .post<TaskGroupType>(this.url, createTaskGroup, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  updateTaskGroup(id: number, updateTaskGroup: UpdateTaskGroupCommand): Observable<TaskGroupType> {
    const url = `${this.url}/${id}`;
    return this.http
      .patch<TaskGroupType>(url, updateTaskGroup, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  deleteTaskGroup(id: number): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http
      .delete<void>(url, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }
}
